import { phrase } from '../i18n/language.js';

const PROMO_TYPE_LABELS = {
  deposit: 'Deposit Bonus',
  newuser: 'New User Bonus',
  referral: 'Referral Bonus',
  refcommission: 'Referral Commission',
  cashback: 'Cashback Bonus',
  reload: 'Reload Bonus',
  freespin: 'Free Spin',
  event: 'Event Promotion',
  custom: 'Promotion',
  first_deposit: 'First Deposit Bonus',
  second_deposit: 'Second Deposit Bonus',
  third_deposit: 'Third Deposit Bonus',
  fourth_deposit: 'Fourth Deposit Bonus',
  fifth_deposit: 'Fifth Deposit Bonus',
  daily: 'Daily Bonus',
  weekly: 'Weekly Bonus',
  affiliate_deposit: 'Affiliate Deposit',
  affiliate_loss: 'Affiliate Commission',
};

export function promoTypeLabel(type) {
  const key = String(type || '').trim();
  if (!key) return '';
  const english = PROMO_TYPE_LABELS[key] || key.replace(/_/g, ' ');
  return PROMO_TYPE_LABELS[key] ? phrase(english) : english;
}

/** Card subtitle from fields the promotions payload already carries. */
export function promoCardSummary(promo) {
  const direct = String(promo?.shortDesc || promo?.summary || promo?.description || '').trim();
  if (direct) return direct;
  const terms = String(promo?.terms || '').replace(/\s+/g, ' ').trim();
  if (!terms || terms.length < 2 || terms.length > 160) return '';
  if (terms === String(promo?.title || '').trim()) return '';
  return terms;
}

export function promoTypeLine(promo) {
  const label = promoTypeLabel(promo?.type);
  const badge = String(promo?.badge || '').trim();
  if (label && badge && badge !== label) return `${label} · ${badge}`;
  return label || badge;
}
